<template>
    <div style="background: #fff">
        <v-container>
        <div class="my-3 mx-5">
            <v-icon style="font-size: 13px;"> 
                fas fa-angle-left
            </v-icon>
            <router-link to="/" class="rous mx-1">
                Back to home
            </router-link> 
        </div>

        <v-layout justify-center row wrap class="my-5">
            <v-divider vertical></v-divider>
            <v-flex xs12 md3 class="mx-3">
                <v-card flat style="border-radius: 0%;">
                    <v-dialog v-model="dialog" width="600" height="600" style="border-radius:0%;">
                        <img :src="imageDialog"
                        style="margin:0 auto;display:block;position:relative;">
                    </v-dialog>
                    <v-card-text style="margin:0 auto;display:block">
                        <img  
                        style="border:solid #ccc 1px;cursor:pointer;" 
                        @click="openDialog({name: procutsSingle.image})" width="300" height="300" :src="procutsSingle.image">
                        <img style="border:solid #ccc 1px;cursor:pointer;" class="mt-2 mr-2" @click="openDialog({name: procutsSingle.image2})" 
                        width="100" :src="procutsSingle.image2">
                        <img style="border:solid #ccc 1px;cursor:pointer;" class="mt-2 mr-2"  @click="openDialog({name: procutsSingle.image3})" 
                        width="100" :src="procutsSingle.image3">
                        <img style="border:solid #ccc 1px;cursor:pointer;" class="mt-2 mr-2" @click="openDialog({name: procutsSingle.imagen4})" 
                        width="100" :src="procutsSingle.imagen4">
                        <img style="border:solid #ccc 1px;cursor:pointer;" class="mt-2 mr-2" @click="openDialog({name: 'https://pipemein.com/img/img_001_pipe.png'})" 
                        width="100" src="https://pipemein.com/img/img_001_pipe.png">
                        <img style="border:solid #ccc 1px;cursor:pointer;" class="mt-2 mr-2" @click="openDialog({name: 'https://pipemein.com/tubos/AmazonN3.jpg'})" 
                        width="100" src="https://pipemein.com/tubos/AmazonN3.jpg">
                        <img style="border:solid #ccc 1px;cursor:pointer;" class="mt-2 mr-2" @click="dialog2 = !dialog2"
                        width="100" height="100" src="https://pipemein.com/files/tabla.png">
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-divider vertical></v-divider>
            <v-flex xs12 md4>
                <v-card flat style="border-radius: 0%;">
                    <v-card-text style="color: #111">
                        <p style="text-rendering: optimizeLegibility;font-weight:600;font-size:18px">
                            {{procutsSingle.name}}
                        </p> 
                        <h4 class="my-2">
                            by <label class="blue--text">pipemein.com</label>
                        </h4>
                        <v-rating
                        v-model="rating" 
                        dense
                        small
                        background-color="orange lighten-3"
                        color="orange"
                        ></v-rating> Avalible: <label class="blue--text">{{procutsSingle.avalible}}</label>
                        
                        <!--<v-divider class="my-3"></v-divider><p> 
                            Price: <label style="font-size: 22px; color: #DD3030">
                            {{procutsSingle.price}}
                        </label> + Shipping. <br>
                        <span><strong>(Pin Connector Not Included).</strong></span>
                        </p>-->
                        <v-divider class="my-2"></v-divider>
                        <div class="ml-2">
                            <p class="black--text subtitle-1">
                                • <v-icon class="mx-1 green--text">fas fa-recycle</v-icon> 
                                <strong>Made with recycled Materials!!!</strong> 
                            </p>
                            <p class="black--text subtitle-1">
                                • <v-icon class="mx-1 green--text">fas fa-recycle</v-icon> 
                                <strong>Reusable: Yes</strong> 
                            </p>
                            <p class="black--text subtitle-1">
                                <strong>• 25% lighter than regular outdoor PVC</strong> 
                            </p>
                            <p class="black--text subtitle-1">
                               <strong>• Compatible with other 3 inch PVC pipes and parts on the market</strong> 
                            </p>
                            <p class="black--text subtitle-1">
                                <strong>• Pipe Color:</strong> <span class="grey--text ml-2"><strong>Gray</strong> </span> 
                            </p>
                            <p class="black--text subtitle-1">
                                <strong>• Pin Color:</strong> <span class="black--text ml-2"><strong>Black</strong> </span> 
                            </p>
                            <p class="black--text subtitle-1">
                                <strong>• UV Resistance</strong>
                            </p>
                            <p class="black--text subtitle-1">
                                <strong>• Fire Resistant pipes avelable 🔥</strong>
                            </p>
                            <p class="black--text subtitle-1">
                                <strong>• DANGER! ⚠️</strong>
                            </p>
                            <p style="font-size:10px;letter-spacing:0;line-height: 20px;">
                            <strong>PIPE WALL MAY CAUSE PINCH POINT</strong><br>


                                Watch fingers and hands when handling the pipe or when inserting cables inside the pipe. The pipe wall has a strong closing grip to remain in a closed position that may cause pinch points to user’s fingers or hands.

                                <br> Use correct protection gear, such as gloves and wire loom cable insertion tools, to decrease chances of serious injury to fingers or hands. Handle pipe at own risk.
                            </p>
                            <p style="font-size:10px;letter-spacing:0;line-height: 20px;">
                            <strong>WARNING!</strong><br>
                            Product includes sharp edges. Use caution during handling. 
                            </p>
                            <p style="font-size:10px;letter-spacing:0;line-height: 20px;">
                            <strong>WARNING!</strong><br>
                                Follow property safety guidelines as dictated by industry standards for the designated task.
                            </p>
                        </div>  
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-divider vertical></v-divider>
            <v-flex xs12 md3 class="mx-1">
                <v-card flat
        style="border-radius: 5px;border: solid #E1E1E1 1px;" width="600">
                    <v-card-text class="text-center title black--text">
                            Contact Us To Make An Order
                    </v-card-text>
                    <v-card-text>
                        <v-form @submit.prevent="enviarEmails()">
                            <label>
                                <span class="black--text">
                                <strong>First Name</strong> 
                                </span>  <br> 
                                <input type="text" v-model="firstname" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>Last Name</strong> 
                                </span>  <br>
                                <input type="text" v-model="lastname" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>Bussiness Name</strong> 
                                </span>  <br>
                                <input type="text" v-model="bussiness" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>Address</strong> 
                                </span>  <br>
                                <input type="text" v-model="address" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>State</strong> 
                                </span>  <br>
                                <input type="text" v-model="states" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>Zip Code</strong> 
                                </span>  <br>
                                <input type="text" v-model="zipcode" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>Phone Number</strong> 
                                </span>  <br>
                                <input type="text" v-model="cellphone" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>Email</strong> 
                                </span>  <br>
                                <input type="email" v-model="email" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>Notes</strong> 
                                </span>  <br>
                                <textarea type="text" v-model="notes" required class="inputArea"></textarea>
                            </label>
                            <v-btn type="submit" class="btns my-2" text>
                            <strong>
                               Order Now  
                            </strong>
                        </v-btn>
                        </v-form>
                        
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

         <v-dialog v-model="dialog2" width="800" style="border-radius:0%;">
                        <v-card flat color="white"
                        style="border-radius:0"
                        >
                            <v-card-text class="pt-2 pb-2 text-center title">
                                Dielectric Strength by ASTM D 149
                            </v-card-text>
                            <v-card-text>
                                <v-simple-table style="border-radius:10px;border:solid 1px #ccc">
                                <template v-slot:default>
                                <thead>
                                    <tr>
                                    <th class="text-center">
                                        Sample No.
                                    </th>
                                    <th class="text-center">
                                        Thickness (mil)
                                    </th>
                                    <th class="text-center">
                                        Breakdown Voltage (kv)
                                    </th>
                                    <th class="text-center">
                                        Dielectric Strength (V/mil)
                                    </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                    v-for="item in datosElec"
                                    :key="item.name"
                                    >
                                    <td class="text-center"><strong>{{ item.canal1 }}</strong></td>
                                    <td class="text-center"><strong>{{ item.canal2 }}</strong></td>
                                    <td class="text-center"><strong>{{ item.canal3 }}</strong></td>
                                    <td class="text-center"><strong>{{ item.canal4 }}</strong></td>
                                    </tr>
                                </tbody>
                                </template>
                            </v-simple-table>
                            </v-card-text>



                            <v-card-text class="pt-2 pb-2 text-center title">
                                Dielectric Strength by ASTM D 150
                            </v-card-text>
                            <v-card-text>
                                <v-simple-table style="border-radius:10px;border:solid 1px #ccc">
                                <template v-slot:default>
                                <thead>
                                    <tr>
                                    <th class="text-center">
                                        Sample No.
                                    </th>
                                    <th class="text-center">
                                        Dielectric Constant @ 1MHz
                                    </th>
                                    <th class="text-center">
                                        Dissipation Factor
                                    </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                    v-for="item in datosElec2"
                                    :key="item.name"
                                    >
                                    <td class="text-center"><strong>{{ item.canal1 }}</strong></td>
                                    <td class="text-center"><strong>{{ item.canal2 }}</strong></td>
                                    <td class="text-center"><strong>{{ item.canal3 }}</strong></td>
                                    </tr>
                                </tbody>
                                </template>
                            </v-simple-table>
                            </v-card-text>
                            <v-card-text>
                                <div @click="dialog2 = !dialog2" style="
                                cursor:pointer;
                                font-size:12px;color:black;text-decoration:none;">
                                    <i class="fas fa-angle-left pr-1"></i>
                                    <span>Back</span>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-dialog>

        <!--<p class="text-left display-1 black--text">
            Frequently Bought Together
        </p>
        <div style="border-bottom: solid orange 2px;"></div>
        
        <v-img style="width:60%" class=" my-4 hidden-md-and-down" src="https://pipemein.com/files/pipemein/image/bestSell.jpg"></v-img>
        <v-img class="hidden-md-and-up my-4 " src="https://pipemein.com/files/pipemein/image/bestSell.jpg"></v-img>
        --></v-container>
    </div>
</template>


<style>

.inputArea {
    background-color: #fff;
    height: 80px;
    padding: 3px 7px;
    line-height: normal;
    color: #333;
    border: solid #a6a6a6 1px;
    border-top-color: #949494;
    border-radius: 3px;
    box-shadow: 0 1px 0 rgba(255,255,255,.5), 0 1px 0 rgba(0,0,0,.07) inset;
    outline: 0;
    font-weight: 500;
    text-align: center;
    width: 100%;
}
.inputArea:focus {
    border-color: #e77600;
    box-shadow: 0 0 3px 2px rgba(228,121,17,.5);
}

.inputTxt {
    background-color: #fff;
    height: 31px;
    padding: 3px 7px;
    line-height: normal;
    color: #333;
    border: solid #a6a6a6 1px;
    border-top-color: #949494;
    border-radius: 3px;
    box-shadow: 0 1px 0 rgba(255,255,255,.5), 0 1px 0 rgba(0,0,0,.07) inset;
    outline: 0;
    font-weight: 500;
    text-align: center;
    width: 100%;
}
.inputTxt:focus {
    border-color: #e77600;
    box-shadow: 0 0 3px 2px rgba(228,121,17,.5);
}
.btns {
    
    background: rgba(255,183,0,1);
    background: -moz-linear-gradient(top, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255,183,0,1)), color-stop(100%, rgba(232,139,0,1)));
    background: -webkit-linear-gradient(top, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    background: -o-linear-gradient(top, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    background: -ms-linear-gradient(top, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    background: linear-gradient(to bottom, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffb700', endColorstr='#e88b00', GradientType=0 );
    color: #111;
    padding: 10px 20px 10px 20px;
}
    .rous {
        text-decoration: none;
        color: gray;
        font-size: 15px;
    }
    .rous:hover {
        text-decoration: underline;
    }
</style>

<script>
import { mapState, mapActions } from "vuex";
let emailjs = require('emailjs-com') 
export default {
    data() {
        return {
            datosElec:[
                {
                    canal1: 'Rigid PVC', 
                    canal2: '121.1', 
                    canal3:'55.0', 
                    canal4: '454'
                },
                {
                    canal1: '', 
                    canal2: '118.2', 
                    canal3:'54.5', 
                    canal4: '461'
                },
                {
                    canal1: '', 
                    canal2: '120.6', 
                    canal3:'52.5', 
                    canal4: '436'
                },
                {
                    canal1: '', 
                    canal2: '115.5', 
                    canal3:'52.0', 
                    canal4: '450'
                },
                {
                    canal1: '', 
                    canal2: '117.5', 
                    canal3:'52.5', 
                    canal4: '447'
                },
                {
                    canal1: '', 
                    canal2: '', 
                    canal3:'', 
                    canal4: 'AV = 450'
                },
                {
                    canal1: '', 
                    canal2: '', 
                    canal3:'', 
                    canal4: '± 9.6'
                }
            ],
            datosElec2:[
                {
                    canal1: 'Rigid PVC', 
                    canal2:'3.27',
                    canal3:'0.0189'
                },
                {
                    canal1: '', 
                    canal2:'3.31',
                    canal3:'0.0196'
                },
                {
                    canal1: '', 
                    canal2:'3.41',
                    canal3:'0.0220'
                },
                {
                    canal1: '', 
                    canal2:'AV = 3.33',
                    canal3:'AV = 0.0195'
                },
                {
                    canal1: '', 
                    canal2:'± 0.06',
                    canal3:'± 0.0004'
                }
            ],
            imageDialog:'',bussiness:'',id: this.$route.params.id, rating: 5,dialog: false,
            firstname:'', lastname:'',email:'',notes:'', quantity:'', cellphone:'', zipcode: '',dialog2:false,
            states: '', address:''
        }
    },
    created() {
        this.getProductSingle(this.id),
        emailjs.init("user_pm8uhtDDgKD9Xm6QNC8Xf")
    },
    computed: {
        ...mapState(['procutsSingle']) 
    },
    methods: {
        ...mapActions(['getProductSingle']),
        openDialog(e){
            this.imageDialog = e.name
            this.dialog = true;
        },
        async enviarEmails(){ 
            try {
                let data = {
            from_email: this.email,
            from_name: this.firstname,
            bussiness: this.bussiness,
            to_email: 'luigicampos86@gmail.com',
            to_name: 'Luis Campos',
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email,
            state: this.states,
            zipcode: this.zipcode,
            cellphone: this.cellphone,
            notes: this.notes,
            address: this.address
            }
            emailjs.send("gmail", "template_LDLGkoDV", data) 
            .then(res=>{ 
                if (res.text === "OK") {
                    alert("Thank you for your request. You will be contacted within 24 hours.");
                    this.firstname = '' 
                    this.lastname = ''
                    this.bussiness = ''
                    this.cellphone = ''
                    this.address = ''
                    this.zipcode = ''
                    this.cellphone = ''
                    this.states = ''
                    this.notes = ''
                }
            }).catch(e=>{
                console.log(e.message)
            })
            } catch (error) {
                alert(error.message) 
            }
            finally {
                
            }
        }
    }
}
</script>